import { render, staticRenderFns } from "./increaseInApp.vue?vue&type=template&id=23bdf1b2&scoped=true"
import script from "./increaseInApp.vue?vue&type=script&lang=js"
export * from "./increaseInApp.vue?vue&type=script&lang=js"
import style0 from "./increaseInApp.vue?vue&type=style&index=0&id=23bdf1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdf1b2",
  null
  
)

export default component.exports